import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { withRouter } from 'react-router-dom'

import LeadRoutes from './routes'

import { BackTop } from 'antd'
import history from '../../history'
import { LeadMenu } from './components/LeadMenu.component'
import LeadTitle from '../../components/LeadTitle'
import LeadDetails from '../../components/LeadDetails'

import * as leadSelectors from '../../selectors/lead/lead'

const propTypes = {}

class LeadMain extends Component {
  constructor(props) {
    super(props)

    this.state = {
      current: this.props.match.params.shortcutPage
        ? this.props.match.params.shortcutPage
        : 'Lead Attachments',
      shortcutItemId: this.props.match.params.shortcutId
        ? this.props.match.params.shortcutId
        : null,
      detailShowing: true
    }
  }

  updateDimensions = () => {
    const w = window
    const d = document
    const documentElement = d.documentElement
    const body = d.getElementsByTagName('body')[0]
    const width = w.innerWidth || documentElement.clientWidth || body.clientWidth
    const height = w.innerHeight || documentElement.clientHeight || body.clientHeight
    this.setState({
      screenWidth: width,
      screenHeigth: height
    })
  }

  componentDidMount() {
    this.updateDimensions()
    window.addEventListener('resize', this.updateDimensions)
  }
  componentWillUnmount() {
    window.removeEventListener('resize', this.updateDimensions)
  }

  navTo = (id, type) => {
    this.setState({
      current: 'Schedule Applications/Permits',
      scheduleApplicationId: id,
      scheduleApplicationType: type
    })
  }

  handleShortcut = (page, itemId) => {
    this.setState({
      current: page,
      shortcutItemId: itemId
    })
  }

  clearHighlight = () => {
    this.setState({
      scheduleApplicationId: 0,
      scheduleApplicationType: '',
      shortcutItemId: null
    })
  }

  handleClick = e => {
    history.push(e.key)
    this.setState({
      current: e.key,
      detailShowing: false
    })
    if (this.state.screenWidth < 700) {
      document.getElementById('taskHeader').scrollIntoView(true)
      document.getElementById('taskHeader').scrollTop += 12
    }
  }

  toggleDetails() {
    this.setState({
      detailShowing: !this.state.detailShowing
    })
  }

  handleLeadStatusChange = value => {
    this.setState({
      leadStatusValue: value
    })
  }

  handleEditJobClick() {
    this.setState({
      isEditing: !this.state.isEditing
    })
  }
  render() {
    const { leadId } = this.props

    return (
      <div>
        <BackTop />
        <div className="dataHeader">
          <LeadTitle
            handleLeadStatusChange={this.handleLeadStatusChange}
            isEditing={this.state.isEditing}
          />
          <div>
            <LeadMenu
              currentKey={this.state.current}
              screenWidth={this.state.screenWidth}
              handleClick={this.handleClick}
              leadId={leadId}
            />
          </div>
        </div>
        <div className="dataPanel">
          <div className="wrapPanel">
            <div className={this.state.detailShowing ? 'jobGroup' : 'jobGroup hiddenStyle'}>
              <LeadDetails
                handleEditJobClick={() => this.handleEditJobClick()}
                handleSaveJob={this.handleSaveJob}
                isEditing={this.state.isEditing}
                leadStatus={this.state.leadStatusValue}
                handleShortcut={this.handleShortcut}
                shortcutItemId={this.state.shortcutItemId}
              />
            </div>
            <div
              className={
                this.state.detailShowing ? 'toggleVisibilityBar' : 'toggleVisibilityBar rotateDiv'
              }
              onClick={() => this.toggleDetails()}
              id="taskHeader"
            />
            <LeadRoutes leadId={leadId} />
            &copy; G-Tech Elevator Associates LLC
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state, props) => ({
  authentication: state.authentication,
  leadId: leadSelectors.getLeadIdParam(state, props)
})
const mapDispatchToProps = (dispatch, ownProps) => ({
  ...bindActionCreators({}),
  dispatch
})

LeadMain.propTypes = propTypes
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(LeadMain))



// WEBPACK FOOTER //
// ./src/pages/lead/LeadMain.container.js